import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Injectable()
export class TituloService {

  public titulo = new Subject<string>();

  constructor () { }

  setTitulo(titulo: string) {  
    this.titulo.next(titulo);
  }

}